/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@carbon/react';
import { getLocale, documentLanguage } from '../../../Utilities/locale/getLocale.js';
import getDateLocaleFormat from '../../../Utilities/locale/getDateLocaleFormat.js';
import getDateLocalePlaceholder from '../../../Utilities/locale/getDateLocalePlaceholder.js';

var _excluded = ["locale", "children"];
var DatePickerWrapper = function DatePickerWrapper(_ref) {
  var locale = _ref.locale,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  // DatePicker takes _ instead of - for locale, and doesnt support zh-cn, whereas getDate
  // utilities only support -, and both zh-cn and zh
  var defaultLocale = getLocale(locale);
  var datePickerLocale = defaultLocale.replace(/-/g, '_');
  switch (datePickerLocale) {
    case 'zh_cn':
      datePickerLocale = 'zh';
      break;
    case 'pt_br':
      datePickerLocale = 'pt';
      break;
  }
  // Apply the placeholder to any datepicker chldren that dont have a placeholder specified
  var childArray = React.Children.toArray(children);
  var childrenWithProps = childArray.map(function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      placeholder: child.placeholder || getDateLocalePlaceholder(defaultLocale)
    });
  });
  return /*#__PURE__*/React.createElement(DatePicker, _extends({
    className: "cpc--date-picker",
    locale: datePickerLocale,
    dateFormat: getDateLocaleFormat(defaultLocale)
    // Disabling because we are treating this component as a wrapper and don't want to label everything inside
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props), childrenWithProps);
};
DatePickerWrapper.propTypes = {
  locale: PropTypes.string,
  /**
   * The child nodes.
   */
  children: PropTypes.node
};
DatePickerWrapper.defaultProps = {
  locale: documentLanguage,
  children: null
};
var DatePickerWrapper$1 = DatePickerWrapper;

export { DatePickerWrapper$1 as default };
